module.exports = __webpack_public_path__ + "static/media/bottle-Fallback.b0b826a3.png";